import styled from "styled-components";
import { DatePicker } from "@tailormed/common-client/component/DatePicker";

const CustomDatePicker = styled(DatePicker).attrs((props) => ({
  size: "large",
  ...props
}))`
  width: ${(props) => (props.width ? props.width : "228")}px;
`;

export { CustomDatePicker };
